import { render, staticRenderFns } from "./Tennis.vue?vue&type=template&id=3b603c93&scoped=true"
import script from "./Tennis.vue?vue&type=script&lang=js"
export * from "./Tennis.vue?vue&type=script&lang=js"
import style0 from "./Tennis.vue?vue&type=style&index=0&id=3b603c93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b603c93",
  null
  
)

export default component.exports